import { font } from '@approvalmax/ui';
import styled from 'styled-components';

export const TextStyled = styled.div`
    ${font(11, '#777d81', 'semibold')}
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;
